module.exports.once = require('./once').default;
module.exports.interval = require('./interval').default;
module.exports.istouch = require('./isTouch').default;
